/**
 * 我销售的房屋竞价列表页面地址
 */
export const HOUSE_AUCTION_SALE_LIST_PAGE_PATH = '/auction/house/list/sale'
